var map = {
	"./audio-placeholder": 627,
	"./audio-placeholder.png": 627,
	"./avatar-missing": 550,
	"./avatar-missing.png": 550,
	"./avatar-missing.svg": 988,
	"./halloween/clouds": 628,
	"./halloween/clouds.png": 628,
	"./halloween/halloween-emblem": 804,
	"./halloween/halloween-emblem.svg": 804,
	"./halloween/spider": 805,
	"./halloween/spider.svg": 805,
	"./halloween/spiderweb": 806,
	"./halloween/spiderweb.svg": 806,
	"./halloween/starfield": 807,
	"./halloween/starfield.png": 807,
	"./halloween/twinkle": 808,
	"./halloween/twinkle.svg": 808,
	"./header-missing": 556,
	"./header-missing.png": 556,
	"./soapbox-logo": 557,
	"./soapbox-logo-white": 558,
	"./soapbox-logo-white.svg": 558,
	"./soapbox-logo.svg": 557,
	"./sprite-post-functions": 809,
	"./sprite-post-functions.png": 809,
	"./video-placeholder": 810,
	"./video-placeholder.png": 810,
	"./void": 811,
	"./void.png": 811,
	"./web-push/web-push-icon_expand": 826,
	"./web-push/web-push-icon_expand.png": 826,
	"./web-push/web-push-icon_favourite": 827,
	"./web-push/web-push-icon_favourite.png": 827,
	"./web-push/web-push-icon_reblog": 828,
	"./web-push/web-push-icon_reblog.png": 828
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 987;